import { ISuggestionEntry } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { ResultsDropdownSectionWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownSectionWrapper";
import { Row } from "@faire/web/slate/Layout";

export const PillsWithImageRow: React.FC<{
  sectionHeader: string;
  suggestionArray: ISuggestionEntry[];
  sectionIndex: number;
  query: string;
  children: React.ReactNode;
}> = ({ sectionHeader, suggestionArray, sectionIndex, query, children }) => {
  return (
    <ResultsDropdownSectionWrapper
      sectionHeader={sectionHeader}
      suggestionArray={suggestionArray}
      sectionIndex={sectionIndex}
      query={query}
    >
      <Row
        className="flex flex-wrap px-2.5 py-0.5"
        align="center"
        tabIndex={-1}
      >
        {children}
      </Row>
    </ResultsDropdownSectionWrapper>
  );
};
